export default "__VITE_ASSET__OtxfBqW___"